import React, { useEffect, useRef } from 'react';
import Collapsible from 'react-collapsible';
import {
  Box,
  makeStyles,
} from '@material-ui/core';


const useStyles = makeStyles(() => {
  return {
    sectionTitle: {
      fontSize: 20,
      fontWeight: 700,
    },
  };
});

const FAQ = () => {
  const classes = useStyles();
  const emailWhitelistRef = useRef();

  useEffect(() => {
    const urlId = window.location.href.split('#')[1];
    if (urlId && emailWhitelistRef.current) {
      const refId = emailWhitelistRef.current.id;

      if (urlId === refId) {
        emailWhitelistRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <div className="content">
      <div className="container">
        <h1>Naked News FAQ</h1>
        <p className="h4">
          Below you'll find answers to the most common
          questions our viewers ask:
        </p>
        <h2>QUESTIONS</h2>
        <ul>
          <li>
            <a href="#1">
              My PASSWORD doesn't work. What should I do?
            </a>
          </li>
          <li>
            <a href="#2">
              I have a question regarding charges to my
              credit card. What do I need to do?
            </a>
          </li>
          <li>
            <a href="#3">
              How often do you update the program?
            </a>
          </li>
          <li>
            <a href="#4">How do I watch the program?</a>
          </li>
          <li>
            <a href="#5">
              What are the different types of video
              formats you offer and which should I use?
            </a>
          </li>
          <li>
            <a href="#6">
              What happened to the Flash Video?
            </a>
          </li>
          <li>
            <a href="#7">
              What are the system requirements for the
              h.264 videos?
            </a>
          </li>
          <li>
            <a href="#8">
              How can I write to the cast members of the
              Naked News?
            </a>
          </li>
          <li>
            <a href="#9">What is a Cookie?</a>
          </li>
          <li>
            <a href="#10">I'm not receiving emails from Naked News or Fan Zone</a>
          </li>
          <li>
            <a href="#11">I'm a Roku user, how do I view Naked News?</a>
          </li>
          <li>
            <a href="#12">What are ways I can view Naked News on my TV?</a>
          </li>
        </ul>
        <h2>ANSWERS</h2>
        <ol>
          <li id="1">
            <Collapsible
              open={true}
              transitionTime={200}
              trigger="My PASSWORD doesn t work. What should i do?"
              triggerClassName="btn-link"
              triggerOpenedClassName="btn-link"
            >
              <p>
                To login as a member, you need to enter
                your username and password exactly as
                they appear on our confirmation receipt
                which was sent to you by email. It is
                best to copy and paste each directly
                from the email. If that doesn't work,
                use the lost username or password form
                on the{' '}
                <strong>
                  <a href="/account/login">login</a>
                </strong>{' '}
                and we'll send you your current login
                information.
              </p>
            </Collapsible>
          </li>
          <li id="2">
            <Collapsible
              open={true}
              transitionTime={200}
              trigger="I have a question regarding charges to my
                            credit card. What do I need to do?"
              triggerClassName="btn-link"
              triggerOpenedClassName="btn-link"
            >
              <p>
                Please <a href="/contact">CLICK HERE</a>{' '}
                and provide a detailed explanation
                regarding the changes you would like to
                make and a customer service
                representative will respond shortly to
                assist you. DO NOT INCLUDE YOUR CREDIT
                CARD NUMBER IN ANY CORRESPONDENCE WITH
                US. This information remains SOLELY
                between you and your secure billing
                company and should never be included in
                any correspondence with us, for your own
                protection.
              </p>
            </Collapsible>
          </li>
          <li id="3">
            <Collapsible
              open={true}
              transitionTime={200}
              trigger="How often do you update the program?"
              triggerClassName="btn-link"
              triggerOpenedClassName="btn-link"
            >
              <div>
                <p>
                  The webcast is updated six times per
                  week
                </p>
                <p>
                  <strong>Monday to Friday</strong> -
                  the webcast goes live between 5:00
                  to 6:30 p.m. (North America EST).
                </p>
                <p>
                  <strong>Sunday</strong> - the
                  webcast goes live at 11:00 a.m.
                  (North America EST).
                </p>
              </div>
            </Collapsible>
          </li>
          <li id="4">
            <Collapsible
              open={true}
              transitionTime={200}
              trigger="How do I watch the program?"
              triggerClassName="btn-link"
              triggerOpenedClassName="btn-link"
            >
              <p>
                To watch Naked news, you need to use a recent generation
                Browser that supports HTML5. For more
                detailed information please check{' '}
                <a href="https://videojs.com/html5-video-support/">
                  https://videojs.com/html5-video-support/
                </a>
              </p>
            </Collapsible>
          </li>
          <li id="5">
            <Collapsible
              open={true}
              transitionTime={200}
              trigger="What are the different types of video
                            formats you offer and which should I use?"
              triggerClassName="btn-link"
              triggerOpenedClassName="btn-link"
            >
              <div>
                <p />
                <ul>
                  <li>
                    We currently offer h.264. It is
                    a standard for video
                    compression, and is currently
                    one of the most commonly used
                    formats for the recording,
                    compression, and distribution of
                    high definition video.
                  </li>
                  <li>
                    JavaScript is required to view the
                    clips. See the{' '}
                    <a href="#10">
                      system requirements
                    </a>{' '}
                    below.
                  </li>
                </ul>
                <p />
              </div>
            </Collapsible>
          </li>
          <li id="6">
            <Collapsible
              open={true}
              transitionTime={200}
              trigger="What happened to the Flash Video?"
              triggerClassName="btn-link"
              triggerOpenedClassName="btn-link"
            >
              <div>
                <p>
                  We switched from Flash
                  Video to h.264. h.264 offers higher
                  quality in files of comparable size.
                  For example, new low quality h.264
                  clips are near the quality of the
                  the old Flash hi clips, while being
                  about the size of low quality Flash
                  videos.
                </p>
                <p>
                  All the new programming is offered
                  in 1080p HD, 720p HD and 480p
                  qualities. The HD clips do require a
                  more powerful computer to play, but
                  for those that are able, we think
                  you'll be pleased. For the customers
                  that find the HD versions too
                  demanding with their computer's
                  resources, we are pleased to offer a
                  480p version that will certainly
                  please them without compromising on
                  the video quality.
                </p>
                <p>
                  If you have any questions about the
                  new player and video formats, please
                  check the rest of the FAQ, as your
                  question may have already been
                  answered. If you can't find the
                  answer you're looking for, feel free
                  to <a href="/contact">contact us</a>{' '}
                  at any time.
                </p>
              </div>
            </Collapsible>
          </li>
          <li id="7">
            <Collapsible
              open={true}
              transitionTime={200}
              trigger="What are the system requirements for the
                            h.264 videos?"
              triggerClassName="btn-link"
              triggerOpenedClassName="btn-link"
            >
              <div>
                <p>Internet Connection:</p>
                <p>
                  A broadband connection with at least
                  500+Kbps will provide the ideal
                  viewing platform for our clips. This
                  will allow you to view our videos with minimal video
                  buffer.
                </p>
                <p>Web Browser:</p>
                <p>
                  We require that you have a recent generation
                  web browser to view the h.264 clips in
                  the embedded player.
                </p>
                <p>
                  <a href="https://videojs.com/html5-video-support/">
                    https://videojs.com/html5-video-support/
                  </a>{' '}
                  - VideoJS browser support
                </p>
              </div>
            </Collapsible>
          </li>
          <li id="8">
            <Collapsible
              open={true}
              transitionTime={200}
              trigger="How can I write to the cast members of the
                            Naked News?"
              triggerClassName="btn-link"
              triggerOpenedClassName="btn-link"
            >
              <p>
                All fan mail for the Naked News Anchors
                can be directed{' '}
                <a href="/contact">here.</a> Each
                incoming email will be passed on to the
                appropriate anchor to see but you will
                not get a reply from the anchor.
              </p>
            </Collapsible>
          </li>
          <li id="9">
            <Collapsible
              open={true}
              transitionTime={200}
              trigger="What is a Cookie?"
              triggerClassName="btn-link"
              triggerOpenedClassName="btn-link"
            >
              <p>
                A "Cookie" is a small piece of data that
                a website sends to your computer to make
                your surfing easier. By doing the
                record-keeping for you - saving
                passwords, noting which plug-ins you
                have, and so on -- cookies make surfing
                faster, more personal, and more
                efficient.
              </p>
            </Collapsible>
          </li>
          <li ref={emailWhitelistRef} id="10">
            <Collapsible
              open={true}
              transitionTime={200}
              trigger="I'm not receiving emails from Naked News or Fan Zone"
              triggerClassName="btn-link"
              triggerOpenedClassName="btn-link"
            >
              <p>
                Most email providers now routinely employ anti-spam software. To make sure that you receive your verification email from Naked News please select your email provider from the list below and follow the instructions provided.
              </p>
              <Box>
                <p className={classes.sectionTitle}>America Online (AOL)</p>
                <ol>
                  <li>Locate the <strong>Contacts</strong> option on the left navigation bar of your AOL Mail Home Page (under the Trash folder).</li>
                  <li>Click <strong>New Contact</strong> icon.</li>
                  <li>Type the contact information in the required and optional fields.</li>
                  <li>Scroll to the bottom and click <strong>Add Contact</strong>.</li>
                  <li>A confirmation message that the contact has been created will appear.</li>
                  <li>Repeat steps 2 through 5 for these email addresses:</li>
                </ol>
                <Box pl={2} pt={1}>
                  <ul>
                    <li>info@nakednews.com</li>
                    <li>support@nakednews.com</li>
                    <li>feedback@nakednews.com</li>
                  </ul>
                </Box>
              </Box>
              <Box mt={2}>
                <p className={classes.sectionTitle}>Gmail</p>
                <ol>
                  <li>Click the gear icon in the upper right, then choose <strong>"see all settings"</strong></li>
                  <li>Click filters and blocked addresses, then scroll down and click "create a new filter"</li>
                  <li>Type info@nakednews.com | support@nakednews.com | feedback@nakednews.com in the "from" field, and click <strong>"create filter"</strong></li>
                  <li>On the next screen click <strong>"never send it to spam"</strong> and click <strong>"create filter"</strong></li>
                </ol>
              </Box>
              <Box mt={2}>
                <p className={classes.sectionTitle}>Hotmail/Outlook</p>
                <ol>
                  <li>Click the gear icon in the top right, then click <stron>"View all Outlook settings"</stron></li>
                  <li>Click <strong>"Email"</strong>, then <strong>"Junk email"</strong>.</li>
                  <li>Scroll down to <strong>"Safe senders and domains"</strong></li>
                  <li>Click <strong>"+ Add"</strong></li>
                  <li>Type the email in the box provided and press enter on your keyboard. Repeat for each of the following:</li>
                </ol>
                <Box pl={2} pt={1}>
                  <ul>
                    <li>info@nakednews.com</li>
                    <li>support@nakednews.com</li>
                    <li>feedback@nakednews.com</li>
                  </ul>
                </Box>
              </Box>
              <Box mt={2}>
                <p className={classes.sectionTitle}>Other ISPs</p>
                <ol>
                  <li>Add the following addresses to any address books or safe lists with your email service provider:</li>
                </ol>
                <Box pl={2} pt={1}>
                  <ul>
                    <li>info@nakednews.com</li>
                    <li>support@nakednews.com</li>
                    <li>feedback@nakednews.com</li>
                  </ul>
                </Box>
              </Box>
              <Box mt={2}>
                <p className={classes.sectionTitle}>Yahoo! Mail</p>
                <ol>
                  <li>In the upper right, click the "contacts" icon. It is next to the calendar icon.</li>
                  <li>Click add a new contact at the bottom of that panel.</li>
                  <li>Type nakednews in the name field and scroll down to "Email". Type the email address there and click "add email address" for additional email fields. We recommend adding the following emails:</li>
                </ol>
                <Box pl={2} pt={1}>
                  <ul>
                    <li>info@nakednews.com</li>
                    <li>support@nakednews.com</li>
                    <li>feedback@nakednews.com</li>
                  </ul>
                </Box>
              </Box>
            </Collapsible>
          </li>
          <li id="11">
            <Collapsible
              open={true}
              transitionTime={200}
              trigger="I'm a Roku user, how do I view Naked News?"
              triggerClassName="btn-link"
              triggerOpenedClassName="btn-link"
            >
              <p>
                As Of February 23, 2022, Roku has removed private channels.
                You can still view Naked News by following any one of the methods listed below,
              </p>
              <Box>
                <p className={classes.sectionTitle}>For Roku users</p>
                <p><b>Using your device's web browser</b></p>
                <p>	If you are using a Roku, you can get access to Naked News through the web browser. </p>
                <ol>
                  <li>Install a browser from the <strong>Roku channel store.</strong> </li>
                  <li>Roku has two available web browsers in their channel store. </li>
                  <li>Web Browser X or Poprism Web Browser. </li>
                  <li>Scroll to the bottom and click <strong>Add Contact</strong>.</li>
                  <li>Once installed, open the web browser on your Roku device and navigate to "nakednews.com" </li>
                  <li>Login with your account and stream.</li>
                </ol>
              </Box>
              <br />
              <Box>
                <p><b>Screen Mirroring from your device.</b></p>
                <p>	Before Roku screen mirroring from an Android device, it's important to check if the Roku
                  and Android devices both support it. New Roku devices released after 2017 do support screen
                  mirroring, as do Android devices running the 4.2 operating system or later.
                </p>
                <p>To screen mirror from Android to Roku, follow this five-step process</p>
                <ol>
                  <li>Ensure the Android and Roku devices have the latest updates installed.</li>
                  <li>Depending on the Android device being used, look for a term called
                    AllShare Cast, display mirroring, HTV Connect, Quick Connect, SmartShare,
                    Smart View, or wireless display.</li>
                  <li>Head to the Android device's settings menu and enable screen mirroring. This is typically
                    done within a submenu like cast, connection, display, or network.
                  </li>
                  <li>On the Roku device, open the Settings menu, select System, then Screen mirroring, and ensure
                    "Enable screen mirroring" is checked.
                  </li>
                  <li>With the feature enabled, select the Roku streaming device or Roku TV from the list of devices
                    that appear and request a connection.
                  </li>
                  <li>Start screen mirroring the Android device onto the Roku.</li>
                </ol>
              </Box>
              <br />
              <Box>
                <p><b>Screen mirror to Roku from a Windows device</b></p>
                <p>	Screen mirroring from a Windows device to a Roku depends on the Windows operating system version you have.
                  It also only works on Windows PCs that include Miracast compatible hardware.
                </p>
                <p><b>Windows 8.1 users can follow this three-step process</b></p>
                <ol>
                  <li>Turn on the Roku device and open the Settings menu, select System, then Screen mirroring,
                    and make sure the "Enable screen mirroring" option is checked.
                  </li>
                  <li>Press the Windows and C keys, select Devices then Project.</li>
                  <li>Select the Add a wireless display option then the desired Roku device.
                  </li>
                </ol>
              </Box>
              <br />
              <Box>
                <p><b>Windows 10 users can screen mirror through these four steps</b></p>
                <ol>
                  <li>Turn on the Roku device and open the Settings menu, select System, then Screen mirroring,
                    and make sure the "Enable screen mirroring" option is checked.
                  </li>
                  <li>Open the Display tab in the Windows device"s Settings menu and scroll down to Connect to a
                    wireless display.
                  </li>
                  <li>Alternatively, simply type "Connect to a wireless display" in the device"s search tab in the toolbar.
                  </li>
                  <li>Select Connect to a wireless display and a list of available devices will pop up.</li>
                  <li>Select the Roku device, and the Windows computer will automatically begin mirroring onto the TV.</li>
                </ol>
              </Box>
              <br />
              <Box>
                <p><b>Windows 10 users can screen mirror through these four steps</b></p>
                <ol>
                  <li>Turn on the Roku device and open the Settings menu, select System, then Screen mirroring,
                    and make sure the "Enable screen mirroring" option is checked.
                  </li>
                  <li>Open the Display tab in the Windows device"s Settings menu and scroll down to Connect to a
                    wireless display.
                  </li>
                  <li>Alternatively, simply type "Connect to a wireless display" in the device"s search tab in the toolbar.
                  </li>
                  <li>Select Connect to a wireless display and a list of available devices will pop up.</li>
                  <li>Select the Roku device, and the Windows computer will automatically begin mirroring onto the TV.</li>
                </ol>
              </Box>
            </Collapsible>
          </li>
          <li id="12">
            <Collapsible
              open={true}
              transitionTime={200}
              trigger="What are ways I can view Naked News on my TV?"
              triggerClassName="btn-link"
              triggerOpenedClassName="btn-link"
            >
              <p>
                To get Naked News on your TV, follow any one of the methods listed below,
              </p>
              <Box>
                <p><b>Using a streaming device such as Amazon FireTvStick or others</b></p>
                <p>You can watch Naked News on your streaming device by opening your Web Browser and going to 'nakednews.com'</p>
              </Box>

              <Box>
                <p><b>Using your Smart TV</b></p>
                <p>You can watch Naked News on your Smart TV by opening your Web Browser and going to 'nakednews.com'</p>
              </Box>

              <Box>
                <p><b>Using Chromecast</b></p>
                <p>You can use Chromecast to stream content from a computer or mobile device, then connect your device to Chromecast and stream. </p>
                <p>For help setting up, refer to these links</p>
                <p><a href="https://support.google.com/chromecast/answer/2998456" rel="noreferrer" target="_blank">Setting up your Chromecast device</a></p>
                <p><a href="https://support.google.com/chromecast/answer/3228332?hl=en-CA&co=GENIE.Platform%3DAndroid&oco=0" rel="noreferrer" target="_blank">Casting to a Chromecast device</a></p>
              </Box>

              <Box>
                <p><b>Using a HDMI cable</b></p>
                <p>You can use a HDMI cable to connect your device directly to the TV, as long as both have HDMI ports.
                  For Macs with Thunderbolt 3 ports, you will need the neccessary connectors.</p>
              </Box>
              <br />
            </Collapsible>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default FAQ;
